<script>
  // @ts-check
  import DynamicHeading from "../../atoms/DynamicHeading.svelte";
  import DynamicHeadingContext from "../../atoms/DynamicHeadingContext.svelte";
  import FormViewContainer from "./FormViewContainer.svelte";
  import Link from "../../atoms/Link.svelte";

  /** Primarily used for testing
   * @type {string} */
  export let id = "";

  /**
   * @type { "split" | "stacked" }
   */
  export let layout = "split";

  /**
   * The theme of the confirmation view
   * @type {import('../../utilities/themes.js').ThemeName}
   */
  export let theme = "lightGrey";

  /**
   * Optional featured image
   * @type {import('../../types/shared.js').Image} Image
   */
  export let featuredImage = undefined;

  /** The title of the confirmation view
   * @type {string}
   * */
  export let title = "";

  /** The subtitle of the confirmation view
   * @type {string}
   * */
  export let subtitle = "";

  /**
   * The description of the confirmation view
   * @type {string}
   */
  export let description = "";

  /**
   * The call to action of the confirmation view
   * @type {import('../../types/shared.js').CTA}
   */
  export let cta = null;

  /**
   * Indicates whether the form submission was successful
   * @type {boolean}
   */
  export let isFormSubmitSuccess = false;
</script>

<FormViewContainer
  id="confirmation-view-{id}"
  {layout}
  {theme}
  {featuredImage}
  {title}
  {description}
  {isFormSubmitSuccess}
  hasEmbedCta={!!cta?.htmlSnippet}
>
  <svelte:fragment slot="main">
    <DynamicHeadingContext>
      <!-- html snippet -->
      {#if cta?.htmlSnippet}
        <div class={"flex flex-col md:items-center"}>
          <DynamicHeading id="confirmation-view-{id}-subtitle" class="heading-xs">
            {subtitle}
          </DynamicHeading>

          <div
            id="confirmation-view-{id}-cta"
            class="flex w-full justify-center"
            data-chromatic="ignore"
          >
            <!--eslint-disable-next-line svelte/no-at-html-tags -->
            {@html cta.htmlSnippet}
          </div>
        </div>
      {:else}
        <!-- link component -->
        <div class="pb-8 md:pb-15 lg:pb-0">
          <DynamicHeading id="confirmation-view-{id}-subtitle" class="heading-xs">
            {subtitle}
          </DynamicHeading>

          <p id="confirmation-view-{id}-description" class="pt-3 lg:pt-5">{description}</p>

          {#if cta}
            <Link
              id="confirmation-view-{id}-cta"
              class="mt-10"
              href={cta.url}
              label={cta.text}
              variant="large"
            />
          {/if}
        </div>
      {/if}
    </DynamicHeadingContext>
  </svelte:fragment>
</FormViewContainer>
